export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14519.fa9d1c79.jpg";